// import moment from 'moment'
import { date } from 'quasar'
import lk from './lk'
import { Base64 } from 'js-base64'
import _ from 'lodash'
let moment = require('moment')

export {
  formatDate,
  formatDateTime,
  createQueryString,
  lk,
  lkKey,
  serializeObject,
  toArrayBuffer,
  b64toBlob,
  formatAddress,
}

function formatDate (unformattedDate, format = 'MM-DD-YYYY') {
  return date.formatDate(unformattedDate, format)
}

function formatDateTime (unformattedDate, format = "YYYY-MM-DD hh:mm:ss") {
  return moment(date).format(format)
}

function createQueryString ({ pagination, columns = [], customFilter, exportOptions }) {
  columns = columns || []
  const filters = columns
  .filter(col => {
    if (typeof col.filter === "string") {
      return !!col.filter
    } else if (typeof col.filter === "object") {
      return _.some(col.filter, val => {
        return !!val 
      })
    } else if (typeof col.filter === 'number') {
      return !!col.filter
    } else if (typeof col.filter === 'boolean') {
      return true
    }
    return false
  })
  .map(col => { return { column: col.name, filter: col.filter, type: col.type } })

  const stringifiedFilters = JSON.stringify(filters)
  const customFilterString = (customFilter) ? JSON.stringify(customFilter) : ''
  let query = `?filters=${stringifiedFilters}&customFilter=${customFilterString}`
  if (pagination) {
    const sortByColumn = columns.filter(col => col.name === pagination.sortBy)
    const sortBy = (sortByColumn[0]) ? sortByColumn[0].sortColumn || sortByColumn[0].field : ''
    query += `&sortBy=${sortBy}&page=${pagination.page}&pageSize=${pagination.rowsPerPage}&descending=${pagination.descending}`
  }
  if (exportOptions) {
    exportOptions.columns = exportOptions.columns
      .map(c => columns.find(d => d.name == c))
      .filter(c => !_.isNil(c))
      // use sortColumn if it's there, otherwise use name
      .map(c => {
        if (c.sortColumn) {
          return c.sortColumn
        }
        return c.name
      })

    query += `&exportOptions=${JSON.stringify(exportOptions)}`
  }
  return query
}

function lkKey (field, value) {
  let result = null
  
  for( let key in lk ){
    if (key == field){
      for( let subKey in lk[key]){
        if (lk[key][subKey] == value){
          result = subKey
        }
      }
    }
  }
  return result
}

function toArrayBuffer(buf) {
  var ab = new ArrayBuffer(buf.length);
  var view = new Uint8Array(ab);
  for (var i = 0; i < buf.length; ++i) {
      view[i] = buf[i];
  }
  return ab;
}

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || ''
  sliceSize = sliceSize || 512

  var byteCharacters = Base64.atob(b64Data)
  var byteArrays = []

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize)

    var byteNumbers = new Array(slice.length)
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    var byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  var blob = new Blob(byteArrays, {type: contentType})
  return blob
}

function serializeObject (obj,prefix){
    var str = [], p
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p]

        str.push((v !== null && typeof v === "object") ?
          serializeObject(v, k) :
          encodeURIComponent(k) + "=" + encodeURIComponent(v))
      }
    }
    return str.join("&")
}

function formatAddress(address) {
  address = address.ADDRESS

  if (!address.ADDRESS_1) {
    return null
  }

  return `${address.ADDRESS_1} ${address.ADDRESS_2} ${address.CITY}, ${address.STATE.STATE} ${address.ZIP_CODE}`
}